// form
import { NumberFormatBase, PatternFormatProps } from 'react-number-format';
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React, { ChangeEvent } from 'react';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
};

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const PhoneFormatCustom = React.forwardRef<PatternFormatProps, CustomProps>(
  function PhoneFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      processInput(event.target.value);
    };

    const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
      const pastedData = event.clipboardData.getData('text');
      processInput(pastedData);
      event.preventDefault(); // Отменяем стандартное поведение вставки
    };

    const processInput = (inputValue: string) => {
      let adjustedValue = inputValue.replace(/[^\d]/g, '');

      if (adjustedValue.startsWith('8')) {
        adjustedValue = '7' + adjustedValue.slice(1);
      }

      onChange({
        target: {
          name: props.name,
          value: adjustedValue,
        },
      });
    };

    const formatPhoneNumber = (val) => {
      if (val === '') return '';
      
      // Замена первой цифры 8 на 7 и удаление всех нецифровых символов
      let cleaned = (val.startsWith('8') ? '7' + val.slice(1) : val).replace(/\D/g, '');
      
      // Форматируем номер, вставляя пробелы и дефисы
      let formatted = '';

      for (let i = 0; i < cleaned.length && i < 11; i++) {
        switch (i) {
          case 0:
            formatted += cleaned[i];
            break;
          case 1:
            formatted += ' (' + cleaned[i] ;
            break;
          case 2:
            formatted += cleaned[i];
            break;
          case 3:
            formatted += cleaned[i];
            break;
          case 4:
            formatted += ') ' + cleaned[i];
            break;
          case 5:
            formatted += cleaned[i];
            break;
          case 6:
            formatted += cleaned[i];
            break;
          case 7:
            formatted += '-' + cleaned[i];
            break;
          case 8:
            formatted += cleaned[i];
            break;
          case 9:
            formatted += '-' + cleaned[i];
            break;
          case 10:
            formatted += cleaned[i];
            break;
          default:
            break;
        }
      }
      
      return formatted;
    };

    return (
      <NumberFormatBase
        {...other}
        getInputRef={ref}
        onChange={handleChange}
        onPaste={handlePaste}
        format={formatPhoneNumber}
      />
    );
  }
);

export function RHFPhone({ name, helperText, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={field.value || ''}
          error={!!error}
          helperText={error ? error.message : helperText}
          InputProps={{
            inputComponent: PhoneFormatCustom as any,
            startAdornment: (
              <InputAdornment position="start">
                +
              </InputAdornment>
            ),
          }}
          {...other}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={{
            ...other.sx,
            '& .MuiInputBase-input': {
              font: 'menu',
            },
          }}
        />
      )}
    />
  );
}
